<template>
  <div class="content">
    <div class="wallet-history">
      <accountDetail tab-name="main" />
      <div class="tabs-mobile" @click="showAccountQuick = true">
        <span>{{ selectActionType }}<i /></span>
      </div>
      <div class="tabs-mobile-list" :class="{ 'active': showAccountQuick }">
        <div class="tabs-mobile-header">
          <span @click="closeAccountQuick()">Done</span>
        </div>
        <ul>
          <li @click="clickQuery('all')">
            {{ $t("Bao.all") }}
          </li>
          <li v-for="(item, key) in commonTransactionStatus" :key="key" @click="clickQuery(key, item)">
            {{ item }}
          </li>
        </ul>
      </div>
      <p class="title">
        {{ $t("Bao.main_wallet_detail") }}
      </p>
      <div class="history-list">
        <ul class="history-list-menu">
          <li v-if="actionType == 'all'" class="active" href="#" @click="clickQuery(item)">
            {{ $t("Bao.all") }}
          </li>
          <li v-else href="#" @click="clickQuery('all')">
            {{ $t("Bao.all") }}
          </li>
          <li v-for="(item, key) in commonTransactionStatus" :key="key" href="#" :value="key" :class="{ 'active': actionType === key }" @click="clickQuery(key)">
            {{ actionType === key ? item : item }}
          </li>
        </ul>
        <div class="history-list-content">
          <div class="history-date">
            <span v-if="record.length !== 0">{{ $t('Bao.transaction_detail') }}</span>
            <p>{{ $t("Bao.date") }}: <datePicker v-model="dateRange" @query="oneQuery" /></p>
          </div>
          <table v-if="record.length !== 0">
            <tr>
              <th>{{ $t("Bao.time") }}</th>
              <th>{{ $t("Bao.type") }}</th>
              <th>{{ $t("Bao.amount") }}</th>
              <th>{{ $t("Bao.tx_balance") }}</th>
              <th>{{ $t("Bao.other") }}</th>
              <th>{{ $t("Bao.order_number") }}</th>
            </tr>
            <tr v-if="record.length == 0 && !loading && !firstLoad">
              <td colspan="6" class="text-center">
                {{ $t("Bao.no_data") }}
              </td>
            </tr>
            <tr v-for="(item, key) in record" v-else :key="key">
              <td :data-title="$t('Bao.time')">
                {{ processedAndSplitDate(item.created_at)[0] }}
                <br>
                {{ processedAndSplitDate(item.created_at)[1] }}
              </td>
              <!-- eslint-disable-next-line -->
              <td :data-title="$t('Bao.type')" v-html="item.action_type_label" />
              <td :data-title="$t('Bao.amount')">
                {{ item.amount | numberFormat }}
              </td>
              <td :data-title="$t('Bao.tx_balance')">
                {{ item.balance | numberFormat }}
              </td>
              <td :data-title="$t('Bao.other')">
                {{ item.action_content }}
              </td>
              <td :data-title="$t('Bao.order_number')">
                {{ item.ref_id }}
              </td>
            </tr>
          </table>
          <div v-if="record.length === 0 && !loading && !firstLoad">
            <div class="no-data">
              <i>
                <img :src="$getThemeImagePath('no-data.png')" alt="">
              </i>
              <p>{{ $t('Bao.no_relevant_data_records') }}</p>
              <span>{{ $t('Bao.search_results_are_empty') }}</span>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <scroll-loader :loader-method="query" :loader-disable="!enableAutoLoad" />
          </div>
        </div>
      </div>
      <div class="history-list-mobile">
        <div class="history-date">
          <span v-if="record.length !== 0">{{ $t('Bao.transaction_detail') }}</span>
          <p>{{ $t("Bao.date") }}: <datePicker v-model="dateRange" @query="oneQuery" /></p>
        </div>
        <div v-if="record.length === 0 && !loading && !firstLoad" class="no-data">
          <i>
            <img :src="$getThemeImagePath('no-data.png')" alt="">
          </i>
          <p>{{ $t('Bao.no_relevant_data_records') }}</p>
          <span>{{ $t('Bao.search_results_are_empty') }}</span>
        </div>
        <table v-for="(item, key) in record" v-else :key="key">
          <tbody>
            <tr>
              <th>{{ $t("Bao.time") }}</th>
              <td :data-title="$t('Bao.time')">
                {{ item.created_at | fullDateTimeFormat }}
              </td>
            </tr>
            <tr>
              <th>{{ $t("Bao.type") }}</th>
              <!--eslint-disable-next-line-->
              <td :data-title="$t('Bao.type')" v-html="item.action_type_label"></td>
            </tr>
            <tr>
              <th>{{ $t("Bao.amount") }}</th>
              <td :data-title="$t('Bao.amount')">
                {{ item.amount | numberFormat }}
              </td>
            </tr>
            <tr>
              <th>{{ $t("Bao.tx_balance") }}</th>
              <td :data-title="$t('Bao.tx_balance')">
                {{ item.balance | numberFormat }}
              </td>
            </tr>
            <tr>
              <th>{{ $t("Bao.other") }}</th>
              <td :data-title="$t('Bao.other')">
                {{ item.action_content }}
              </td>
            </tr>
            <tr>
              <th>{{ $t("Bao.order_number") }}</th>
              <td :data-title="$t('Bao.order_number')">
                {{ item.ref_id }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-center">
          <scroll-loader :loader-method="query" :loader-disable="!enableAutoLoad" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import accountDetail from '@/components/accountDetail'
import datePicker from '@/components/datePicker'
import moment from 'moment'
import { getCommonTransactionStatus } from '@/api/common'
import { getMain } from '@/api/transaction'
import ScrollLoader from 'vue-scroll-loader/src/components/Scroll-Loader'

export default {
  components: {
    datePicker,
    accountDetail,
    ScrollLoader
  },
  data() {
    return {
      dateRange: {
        startDate: moment().subtract(7, 'd'),
        endDate: new Date()
      },
      actionType: 'all',
      record: [],
      commonTransactionStatus: [],
      page: 1,
      pageSize: 50,
      enableAutoLoad: false,
      loading: false,
      firstLoad: true,
      selectActionType: this.$i18n.t('Bao.all'),
      showAccountQuick: false
    }
  },
  async created() {
    const res = await getCommonTransactionStatus()
    this.commonTransactionStatus = res.data.data
    this.oneQuery()
  },
  methods: {
    async query() {
      if (this.loading) return
      this.loading = true
      this.firstLoad = false
      const queryObj = {
        'startDate': moment(this.dateRange.startDate).format('YYYY/MM/DD'),
        'endDate': moment(this.dateRange.endDate).format('YYYY/MM/DD'),
        'page': this.page,
        'page_size': this.pageSize
      }
      if (this.actionType !== 'all') {
        queryObj.action_type = this.actionType
      }
      const res = await getMain(queryObj)
      this.record = [...this.record, ...res.data.data.list]
      if (res.data.data.list.length < this.pageSize) {
        this.enableAutoLoad = false
      } else {
        this.enableAutoLoad = true
        this.page += 1
      }
      this.loading = false
    },
    oneQuery() {
      this.enableAutoLoad = true
      this.page = 1
      this.record = []
      this.query()
    },
    clickQuery(actionType, actionTypeName) {
      this.actionType = actionType
      if (actionType === 'all') {
        this.selectActionType = this.$i18n.t('Bao.all')
      } else {
        this.selectActionType = actionTypeName
      }
      window.scrollTo(0, 0)
      this.enableAutoLoad = true
      this.page = 1
      this.record = []
      this.query()
      this.closeAccountQuick()
    },
    clickToogleAccountQuick() {
      this.showAccountQuick = !this.showAccountQuick
      this.$store.state.app.hideMobileNav = !this.$store.state.app.hideMobileNav
    },
    closeAccountQuick() {
      this.showAccountQuick = false
      this.$store.state.app.hideMobileNav = false
    },
    processedAndSplitDate(formattedTime) {
      const formattedValue = this.$options.filters.fullDateTimeFormat(formattedTime)
      const dataParts = formattedValue.split(' ')
      return dataParts
    }
  }
}
</script>
